import { Box } from "theme-ui";
import { H3 } from "../Headers";
import { useTranslations } from "../../contexts/Translation";
import { useSurvey } from "../../contexts/Survey";
import { useApiData } from "../../contexts/ApiData";
import Input from "../Forms/Input";
import { useState } from "react";
import Button, { IconButton } from "../Button";
import { ValidationError } from "../../types";
import ErrorText from "../Forms/ErrorText";
import { CheckMark, Edit } from "../Icons";
import { useProfile } from "../../contexts/UserProvider";

type ComponentProps = {
  notes: string;
  responder: string;
}

export const ResponderNotes = ({ notes, responder }: ComponentProps) => {
  const t = useTranslations('surveys');
  const { patch } = useApiData();
  const survey = useSurvey();
  const profile = useProfile();
  const [ updatedNotes, setNotes ] = useState(notes || '');
  const [ isSaved, setIsSaved ] = useState(false);
  const [ isEdit, setIsEdit ] = useState(false);
  const [errors, setErrors] = useState<ValidationError[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    setIsSaved(false);
    setNotes(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await patch(`/survey/${survey?.id}/responders/notes`, { responder, notes: updatedNotes });
    if (!result) {
      setErrors([{ name: 'form', message: t('serverError') }]);
    } else {
      setIsSaved(true);
    }
  };
  
  const canEdit = (profile?.userId === survey?.userId && !survey?.onBehalfOf) || profile?.userId === survey?.onBehalfOf;

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <ErrorText sx={{ mt: 32, fontSize: 24, }} error={errors.find(e => e.name === 'form')} />
      <H3>{t('responderNotesHeading')}
          { canEdit && <IconButton sx={{ border: 'none', color: isEdit ? 'primary' : 'mainText'}} onClick={() => setIsEdit(!isEdit)}><Edit /></IconButton> }
      </H3>
      { canEdit && isEdit ? (
        <>
          <Input
            type="textarea"
            name="reflections"
            value={updatedNotes}
            handleChange={handleChange}
            />
          <Button>{t('submitResponderNotes')}</Button> { isSaved && <CheckMark />}
        </>
      ): <Box as="p" sx={{ whiteSpace: 'pre-wrap' }}>{updatedNotes || t('noResponderNotesText')}</Box> }
    </Box>
  );
};
